import { render, staticRenderFns } from "./bet.vue?vue&type=template&id=01036a8c"
import script from "./bet.vue?vue&type=script&lang=js"
export * from "./bet.vue?vue&type=script&lang=js"
import style0 from "./bet.vue?vue&type=style&index=0&id=01036a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports